import { u as n } from "./index-6a632112.mjs";
const t = () => ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, a = n.h1`
  ${t()}
`;
export {
  a as h
};
